import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vShow as _vShow, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "card mb-4 mb-md-0" }
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "svg-icon svg-icon-1 me-2" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Search Panel ")
const _hoisted_6 = { class: "card-toolbar" }
const _hoisted_7 = {
  key: 0,
  class: "d-flex justify-content-end",
  "data-kt-site-table-toolbar": "base"
}
const _hoisted_8 = { class: "svg-icon svg-icon-2" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Add DeliveryChallan ")
const _hoisted_10 = { class: "card-header border-0 pt-6 d-none" }
const _hoisted_11 = { class: "card-toolbar w-100" }
const _hoisted_12 = {
  class: "d-flex w-100 justify-content-between align-items-center",
  "data-kt-site-table-toolbar": "selected"
}
const _hoisted_13 = { class: "me-auto" }
const _hoisted_14 = { class: "form-check form-check-sm form-check-custom form-check-solid" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  for: "",
  class: "ms-3"
}, " All ", -1)
const _hoisted_16 = { class: "fw-bolder mx-5" }
const _hoisted_17 = { class: "me-2" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Selected ")
const _hoisted_19 = { class: "card-header border-0 pt-6" }
const _hoisted_20 = { class: "card-title w-100" }
const _hoisted_21 = { class: "row w-100" }
const _hoisted_22 = { class: "col-md-6 d-flex align-items-center position-relative my-1" }
const _hoisted_23 = { class: "card-toolbar" }
const _hoisted_24 = {
  class: "d-flex justify-content-end align-items-center",
  "data-kt-site-table-toolbar": "selected"
}
const _hoisted_25 = {
  key: 0,
  class: "card-body pt-0"
}
const _hoisted_26 = { class: "form-check form-check-sm form-check-custom form-check-solid" }
const _hoisted_27 = ["value"]
const _hoisted_28 = ["value"]
const _hoisted_29 = { class: "d-flex pt-1 justify-content-end" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil p-0" }, null, -1)
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash p-0" }, null, -1)
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = { class: "d-none" }
const _hoisted_37 = {
  key: 0,
  class: "card"
}
const _hoisted_38 = { class: "card-body" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("h4", null, "No Data Found", -1)
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" to add new deliveryChallan ")
const _hoisted_41 = { class: "card-header ribbon" }
const _hoisted_42 = { class: "card-title" }
const _hoisted_43 = { class: "ribbon-label bg-info" }
const _hoisted_44 = { class: "card-body px-0 pb-0 d-flex align-items-center mb-2" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-vertical h-40px me-3" }, null, -1)
const _hoisted_46 = { class: "flex-grow-1" }
const _hoisted_47 = { class: "d-flex" }
const _hoisted_48 = { class: "ms-4" }
const _hoisted_49 = { class: "text-muted fw-bold d-block" }
const _hoisted_50 = { class: "text-muted fw-bold d-block" }
const _hoisted_51 = { class: "text-muted fw-bold d-block" }
const _hoisted_52 = { class: "card-footer d-flex pt-1" }
const _hoisted_53 = ["onClick"]
const _hoisted_54 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil" }, null, -1)
const _hoisted_55 = [
  _hoisted_54
]
const _hoisted_56 = ["onClick"]
const _hoisted_57 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash" }, null, -1)
const _hoisted_58 = [
  _hoisted_57
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_PartyMultiselect = _resolveComponent("PartyMultiselect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: "d-flex align-items-center position-relative my-1 cursor-pointer",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showSearchPanel = !_ctx.showSearchPanel))
          }, [
            _createElementVNode("span", _hoisted_4, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/abstract/abs027.svg" })
            ]),
            _hoisted_5
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_ctx.hasCreate)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addDeliveryChallan(null)))
                }, [
                  _createElementVNode("span", _hoisted_8, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotone/navigation/Plus.svg" })
                  ]),
                  _hoisted_9
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectAllDeliveryChallan) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.selectAllDeliveryChallan]
                ]),
                _hoisted_15
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.selectAllDeliveryChallan ? _ctx.total : _ctx.checkedDeliveryChallan.length), 1),
              _hoisted_18
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-info me-2",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.exportFewSites()))
            }, " Export CSV Selected ")
          ])
        ])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createVNode(_component_PartyMultiselect, {
                isEdit: true,
                modelValue: _ctx.searchData.party_id,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchData.party_id) = $event)),
                class: "form-control"
              }, null, 8, ["modelValue"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-info me-2",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.searchItems()))
            }, " Search "),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-danger",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.clearFilter()))
            }, " Clear ")
          ])
        ])
      ], 512), [
        [_vShow, _ctx.showSearchPanel]
      ]),
      (!_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
            _createVNode(_component_Datatable, {
              "table-data": _ctx.tableData,
              "table-header": _ctx.tableHeader,
              "enable-items-per-page-dropdown": false,
              total: _ctx.total,
              rowsPerPage: 10,
              onPageChange: _ctx.onPageChange,
              currentPage: _ctx.currentPage
            }, {
              "cell-checkbox": _withCtx(({ row: site }) => [
                _createElementVNode("div", _hoisted_26, [
                  (_ctx.selectAllDeliveryChallan)
                    ? (_openBlock(), _createElementBlock("input", {
                        key: 0,
                        class: "form-check-input",
                        type: "checkbox",
                        value: site.id,
                        checked: "",
                        disabled: ""
                      }, null, 8, _hoisted_27))
                    : _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 1,
                        class: "form-check-input",
                        type: "checkbox",
                        value: site.id,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.checkedDeliveryChallan) = $event))
                      }, null, 8, _hoisted_28)), [
                        [_vModelCheckbox, _ctx.checkedDeliveryChallan]
                      ])
                ])
              ]),
              "cell-challan_number": _withCtx(({ row: site }) => [
                _createTextVNode(_toDisplayString(site.challan_number), 1)
              ]),
              "cell-party": _withCtx(({ row: site }) => [
                _createVNode(_component_router_link, {
                  to: {
                name: 'apps-edit-party',
                params: { id: site.party_data.id },
              }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(site.party_data.companyName), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              "cell-grand_total": _withCtx(({ row: site }) => [
                _createTextVNode(" ₹ " + _toDisplayString(site.grand_total), 1)
              ]),
              "cell-date": _withCtx(({ row: site }) => [
                _createTextVNode(_toDisplayString(_ctx.moment(site.date).format("YYYY-MM-DD")), 1)
              ]),
              "cell-actions": _withCtx(({ row: site }) => [
                _createElementVNode("div", _hoisted_29, [
                  (_ctx.hasEdit)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn btn-primary btn-sm mx-2",
                        onClick: ($event: any) => (_ctx.addDeliveryChallan(site.id))
                      }, _hoisted_32, 8, _hoisted_30))
                    : _createCommentVNode("", true),
                  (_ctx.hasDelete)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        type: "button",
                        class: "btn btn-danger btn-sm mx-2",
                        onClick: ($event: any) => (_ctx.deleteDeliveryChallanItem(site))
                      }, _hoisted_35, 8, _hoisted_33))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["table-data", "table-header", "total", "onPageChange", "currentPage"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_36, [
      _createElementVNode("div", null, [
        (_ctx.tableData.length == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _hoisted_39,
                _createElementVNode("p", null, [
                  _createElementVNode("span", {
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.addDeliveryChallan({}))),
                    class: "cursor-pointer text-primary"
                  }, "Click here"),
                  _hoisted_40
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "card card-flush mb-4 shadow",
            key: item.id
          }, [
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("h3", _hoisted_42, _toDisplayString(item.challan_number), 1),
              _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.userList[item.created_by]?.username), 1)
            ]),
            _createElementVNode("div", _hoisted_44, [
              _hoisted_45,
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("div", {
                    style: _normalizeStyle({
                    backgroundColor: item.color,
                    width: '100px',
                    height: '100px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  })
                  }, _toDisplayString(item.color), 5),
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("div", _hoisted_49, " Unit: " + _toDisplayString(item.unit), 1),
                    _createElementVNode("div", _hoisted_50, " Rate : ₹ " + _toDisplayString(item.rate), 1),
                    _createElementVNode("div", _hoisted_51, " Purchase Cost: ₹ " + _toDisplayString(item.purchaseCost), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary mx-2 w-100",
                onClick: ($event: any) => (_ctx.addDeliveryChallan(item.id))
              }, _hoisted_55, 8, _hoisted_53),
              false
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-danger mx-2 w-100",
                    onClick: ($event: any) => (_ctx.deleteDeliveryChallanItem(item))
                  }, _hoisted_58, 8, _hoisted_56))
                : _createCommentVNode("", true)
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}